module.exports = __webpack_public_path__ + "img/20201107_204037.59879129.jpg";